export default {
      id: "Note_icon_donker_paars-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#Note_icon_donker_paars-usage",
      toString: function () {
        return this.url;
      }
    }